import { Component, EventEmitter, Input, Output, OnInit, DestroyRef, inject } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { CommonModule } from '@angular/common';
import { CreateSupplierComponent } from '../create-supplier.component';
import { DirectoryItem } from '../../../_models/directory.model';
import { SupplierModalService } from '../../../services/supplier/supplier-modal.service';

@Component({
    selector: 'app-create-supplier-modal',
    imports: [
        CommonModule,
        CreateSupplierComponent
    ],
    templateUrl: './create-supplier-modal.component.html',
    styleUrls: ['./create-supplier-modal.component.scss']
})
export class CreateSupplierModalComponent implements OnInit {
  /** Visibilidad del modal */
  @Input() visible: boolean = false;
  
  /** Datos del directorio para pre-poblar el formulario */
  @Input() supplierData: DirectoryItem | null = null;
  
  /** Callback cuando cambia la visibilidad */
  @Output() onVisibleChange = new EventEmitter<boolean>();
  
  /** Callback cuando se cierra el modal sin guardar */
  @Output() onClose = new EventEmitter<void>();

  private readonly destroyRef = inject(DestroyRef);

  constructor(private supplierModalService: SupplierModalService) {}

  ngOnInit(): void {
    this.supplierModalService.open$.pipe(takeUntilDestroyed(this.destroyRef)).subscribe((data) => {
      this.supplierData = data;
      this.open();
    });
  }

  /**
   * Abre el modal
   */
  open(): void {
    this.visible = true;
    this.onVisibleChange.emit(this.visible);
  }

  /**
   * Cierra el modal
   */
  close(): void {
    this.visible = false;
    this.supplierData = null;
    this.onVisibleChange.emit(this.visible);
    this.onClose.emit();
  }

  /**
   * Maneja el cierre del modal desde el backdrop
   */
  onBackdropClick(event: MouseEvent): void {
    if ((event.target as HTMLElement).classList.contains('modal-backdrop')) {
      this.close();
    }
  }
}
